// Copyright (c) 2017 Deere & Company

import SpaAccordion from './spa-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    spaClaims: state.tcsm.wip.specialAllowanceClaims,
    spaClaimsSearchFilters: state.tcsm.wip.specialAllowanceClaimsSearchFilters
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SpaAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/special-allowance/index.js